// Copyright (c) 2019 Deere & Company

import actions from '../../action-list';
import {routerActions} from 'react-router-redux';

export const additionalRepair = claim =>
    dispatch => {

        dispatch({
            data: claim,
            type: actions.ADD_CLAIM_WEAR_PARTS_ADDITIONAL_REPAIR
        });

        dispatch(routerActions.push('/claims/wear-parts/new/'));

    };



// WEBPACK FOOTER //
// ./src/claim/wear-parts/action-creators/additional-repair.js